import React from "react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { RotateCcw, Search } from "lucide-react";

/**
 * 테이블 상단 툴바 공통 컴포넌트
 *
 * @param {ReactNode} left - 좌측 영역 (초기화 버튼, 필터 등)
 * @param {ReactNode} right - 우측 영역 (커스텀 요소, 검색은 내장)
 * @param {string} searchValue - 검색어 (controlled)
 * @param {function} onSearchChange - 검색어 변경 핸들러
 * @param {function} onSearch - 검색 실행 핸들러 (form submit)
 * @param {function} onReset - 초기화 핸들러
 * @param {string} placeholder - 검색 입력 placeholder
 * @param {string} className - 추가 클래스
 */
const TableToolbar = ({
  left,
  right,
  searchValue,
  onSearchChange,
  onSearch,
  onReset,
  placeholder = "아이디, 이름, 또는 추천인",
  className,
}) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    onSearch?.(searchValue);
  };

  return (
    <div className={`flex items-center justify-between mb-2 ${className || ""} px-1`}>
      {/* 좌측 영역: 초기화 버튼 + 커스텀 요소 */}
      <div className="flex items-center gap-2">
        {onReset && (
          <Button variant="outline" onClick={onReset}>
            <RotateCcw className="size-4" />
            초기화
          </Button>
        )}
        {left}
      </div>

      {/* 우측 영역: 커스텀 요소 + 검색 */}
      <div className="flex items-center gap-2">
        {right}
        {onSearch && (
          <form onSubmit={handleSubmit} className="flex items-center gap-1.5">
            <Input
              placeholder={placeholder}
              className="w-72"
              value={searchValue}
              onChange={(e) => onSearchChange?.(e.target.value)}
            />
            <Button type="submit" variant="gradient">
              <Search className="size-4" />
              검색
            </Button>
          </form>
        )}
      </div>
    </div>
  );
};

export default TableToolbar;
